import { createContext, useState, useContext } from "react";
import AddToSlot from "../components/shared/addToSlot";

const SlotContext = createContext();

export const useSlot = () => useContext(SlotContext);

export const SlotProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [card, setCard] = useState(null);
  const [inSlot, setInSlot] = useState(false);

  return (
    <SlotContext.Provider value={{ open, setOpen ,setCard,setInSlot}}>
     <AddToSlot inSlot={inSlot} card={card} setOpen={setOpen} open={open} />
      {children}
    </SlotContext.Provider>
  );
};
